import React, { type ReactNode, type FC } from 'react';
import { Spinner as FriskSpinner } from '@hdir/ui/spinner';


export interface SpinnerProps {
	children?: ReactNode;
	size?: 'small' | 'medium' | 'large';
	variant?: 'normal' | 'inverted';
}


export const Spinner: FC<SpinnerProps> = ({
	children,
	size,
	variant,
}) => {
	return (
		<div className='content-center flex flex-col flex-wrap gap-xxs'>
			<FriskSpinner size={size} variant={variant}/>
			{children}
		</div>
	);
};
